import template from './legendBar.html';
import controller from './legendBar.controller';

let legendBarComponent = {
  restrict: 'E',
  bindings: {
    barTitle: '=?',
    barItems: '=',
    barBottomText: '=?'
  },
  transclude: true,
  template,
  controller,
  controllerAs: 'vm',

};

export default legendBarComponent;



// WEBPACK FOOTER //
// ./app/common/legendBar/legendBar.component.js